import { render, staticRenderFns } from "./MrRegion.vue?vue&type=template&id=64b36d73&"
import script from "./MrRegion.vue?vue&type=script&lang=js&"
export * from "./MrRegion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports